const displayMessage = (message: string, _isError = false) => {
    alert(message);
}

export {displayMessage}